export default __webpack_public_path__ + "static/media/Gesture_white_Shake.5037e17e.svg";